/*=============================================== Container styles ===============================================*/

import styled from "styled-components/macro"
import { Wrapper, Main, Transitions, Spacers } from "tsx-library-julseb"

import { NAV_WIDTH } from "../Nav/styles"

export const StyledWrapper = styled(Wrapper)`
    width: 100%;
    left: 0;
    transition: ${Transitions.Short};
    background-color: transparent;
    flex-direction: column;
    align-items: center;

    &.nav-open {
        width: calc(100% - ${NAV_WIDTH}px);
        left: ${NAV_WIDTH}px;
    }
`

export const StyledContainer = styled(Main)`
    margin-top: 64px;
    padding: ${Spacers.L} 0;
`
